import React from "react";
import styles from "./footer.module.css";
function footer() {
  return <div className={styles.container}></div>;
}

export default footer;
